import React, { useEffect, useContext } from "react";
import toast, { useToasterStore } from "react-hot-toast";
import { owntoast } from "../../utils";
import { useOnlineStatus } from "../../hooks/useOnlineStatus";
import * as Components from "../../components";
import { GlobalContext } from "../../context";
import { Routes, Route, Navigate } from "react-router-dom";
import * as Containers from "../";
import { Layout, Modal, Button } from "antd";
import UsefulFunctions from "../../utils/UsefulFunctions";
import { Admin, Cashier } from "../../utils/enums";
import packageJson from "../../../package.json";
import Snowfall from 'react-snowfall'

function PrivateRoute({ Page, ...props }) {
  if (!props.islogin && !props._auth) {
    return <Navigate to={"/login"} />;
  }
  return <Page {...props} />;
}

function App() {
  const { toasts } = useToasterStore();
  const context = useContext(GlobalContext);
  const isOnline = useOnlineStatus();
  const { pathname } = window.location;

  useEffect(() => {
    toasts
      .filter((t) => t.visible)
      .filter((_, i) => i >= 8)
      .forEach((t) => toast.dismiss(t.id));
  }, [toasts]);

  useEffect(() => {
    function caching() {
      let version = localStorage.getItem("version");
      if (version != packageJson.version) {
        if ("caches" in window) {
          caches.keys().then((names) => {
            names.forEach((name) => {
              caches.delete(name);
            });
          });
          window.location.reload(true);
        }
        localStorage.setItem("version", packageJson.version);
      }
    }
    caching();
  }, []);

  window.onbeforeunload = () => {
    Object.keys(localStorage).map((key) => {
      if (key.includes("pagination") || key.includes("search")) {
        localStorage.removeItem(key);
      }
    });
    localStorage.setItem("editRows", JSON.stringify({}));
  };

  /* Интернэт холболт салах эсвэл холбогдох үед мсж харуулна */
  useEffect(() => {
    if (isOnline) owntoast("Интернэт холболт орлоо.", "success");
    else owntoast("Интернэт холболт саллаа.", "error");
  }, [isOnline]);

  useEffect(() => {
    if (context._auth && context.islogin) {
      context.request({ url: "/user/storelist", model: "store" });
      context.request({
        url: "/sale/category",
        model: "salecategory",
        method: "POST",
      });
      context.request({
        url: "/product/store/dropdown",
        model: "productlist",
        method: "POST",
      });
      context.request({
        url: `/order/dropdown/${context._auth.user.storeid}`,
        model: "orderdroplist",
        method: "POST",
      });
      context.request({
        url: `/main/check`,
        model: "checkService",
        isservice: true,
      });
      context.request({
        url: "/sale/supplier",
        model: "salesupplier",
        method: "POST",
      });
    }
  }, [context._auth]);

  const getSaleRoute = () => {
    let res = UsefulFunctions.checkPermission(context._auth, [Admin, Cashier]);
    if (res) {
      return (
        <Route
          path="/sale"
          element={<PrivateRoute {...context} Page={Containers.Sale} />}
        />
      );
    }
    return null;
  };

  const isShow = () =>
    pathname.includes("login") || pathname.includes("register");
  return (
    <div>
      <Layout className="h-full justify-center items-center fixed w-full">
         <Snowfall
                  snowflakeCount={500}
                  
            />
        {!isShow() ? (
          <Components.Header {...context} />
        ) : (
          <div className="bg-primary h-1 w-full fixed top-0" />
        )}
        <Layout.Content className="w-full" /* style={{ marginTop: 64 }} */>
          <Routes>
            <Route
              path="/"
              element={<PrivateRoute {...context} Page={Containers.Home} />}
            />
            {getSaleRoute()}

            <Route
              path="/management/:id/*"
              element={
                <PrivateRoute {...context} Page={Containers.Management} />
              }
            />
            <Route path="/login" element={<Containers.Login {...context} />} />
          </Routes>
        </Layout.Content>
        {isShow() ? (
          <Components.Footer {...context} />
        ) : (
          <div
            className="bg-primary h-1 w-full bottom-0"
            style={{ zIndex: 9999 }}
          />
        )}
      </Layout>
      <Components.GlobalModal
        footer={[
          <Button
            type="primary"
            autoFocus
            onClick={() => {
              context.setError({ isOpen: false });
            }}
          >
            {"OK"}
          </Button>,
        ]}
        width={400}
        isOpen={context.isOpenError}
        onClose={() => context.setError({ isOpen: false })}
        title="Анхааруулга"
      >
        <div className="py-3 px-10 flex flex-col items-center justify-center">
          <span className="text-center">{context.errorMsg}</span>
        </div>
      </Components.GlobalModal>
    </div>
  );
}

export default App;
